import PropertySelector from "./PropertySelector";

function App() {
  return <PropertySelector /> ;
}

export default App;
